import { useConnection, useChainId } from 'wagmi';
import { useAppDispatch } from 'store/hooks';
import {
  getNetworkFromChainId,
  NetworkChainIds,
} from '@dapp/multi-lib/network';
import { showWalletManageModal } from 'store/features/wallet/walletSlice';
import { Button, ButtonProps } from '@dapp/multi-lib/sdaoui/Button';
import { Icon as Iconify } from '@iconify/react';
import { Typography } from '@dapp/multi-lib/sdaoui/Typography';
import { formatAddress } from 'structure/user/WalletConnect';
import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon } from '@dapp/multi-lib/sdaoui/Icon';

type AccountInfoProps = {
  button?: Pick<ButtonProps, 'style' | 'className'>;
};

export const AccountInfo = (props: AccountInfoProps) => {
  const { button = {} } = props;

  const chainId = useChainId();
  const account = useConnection();
  const dispatch = useAppDispatch();
  const networkConfig = getNetworkFromChainId(chainId as NetworkChainIds);
  const handleModalOpenChange = () => {
    dispatch(showWalletManageModal(true));
  };

  return (
    <Button
      style={button.style ? button.style : 'ghost'}
      className={twMerge(
        'rounded-main flex flex-row gap-1 pl-3 pr-3 hover:bg-[linear-gradient(103deg,_#363636_0%,_#1A1A1A_100%)]',
        button.className
      )}
      onClick={handleModalOpenChange}
    >
      <Iconify
        icon={networkConfig?.icon}
        color='#ffffff'
        width='16'
        height='16'
      />
      <Typography className='text-xs text-[#B4BCD0]'>
        {formatAddress(account.address as string)}
      </Typography>
      <Icon width={24} height={24} color='#B4BCD0' icon={'expand_more'} />
    </Button>
  );
};
